module.exports = __webpack_public_path__ + "img/recolumn_example5.ec4852da.png";